import * as PropTypes from "prop-types"
import React, {Component} from "react"
import {Button, Input, Popup} from "semantic-ui-react"

import shop from "shop/shop"


const showWarningToast = msg => {
	shop.toast( msg, "warning", false, "bottom" )
}



class ProductCount extends Component {



	render() {
		let {product, onChange} = this.props
		let showVEWarning = shop.config.checkout.limitToStock && (product.count >= Math.floor( product.deliveryCount / product.unit_multi ))
		//console.log("PRODUCT COUNT: ", product)
		//console.log("product Count", product)
		return (
			<Input size="tiny" 
				onChange={( e ) => {
					let tempCount = Math.round( Number(e.target.value)+1)
					if((tempCount-1) >= product.extras.deliveryCount / product.unit_multi){
						//showWarningToast( "Maximale Abnahmemenge erreicht" )
						//tempCount = (Number(product.extras.deliveryCount) + 1) / product.unit_multi
						//console.log("tempCount", tempCount)
					}
					const count = tempCount
					//console.log("count", count)
					if ( product.onChange ) {
						let ok = product.onChange( product )
						if ( !ok ) {
							showWarningToast( "Maximale Abnahmemenge erreicht" )
							return false
						}
					}
					product.count = Math.max( product.count - 1, 1 )
					product.count = Number( count )
					//console.log("product", product.count)
					if(product.count == 0){
						product.extras.trueReturnValue = false
						product.count = 1
					}
					else{
						product.extras.trueReturnValue = true
					}
					//console.log("PRODUCT COUNT ON CHANGE", product)
					onChange( {product, count: count} )
				}}
				className="text-center"
				type="number"
				placeholder="0"
				action>
				<Button style={{backgroundColor:"darkGray"}}
					size="tiny"
					icon=" minus"
					onClick={() => {
						if ( shop.config.checkout.limitToStock ) product.count = Math.min( product.count, Math.floor( product.deliveryCount / product.unit_multi ) )
						if ( product.onChange ) {
							let ok = product.onChange( {count: product.count - 1} )
							/*if ( !ok ) {
								showWarningToast( "Maximale Abnahmemenge erreicht" )
								return false
							}*/
						}
						product.count = Math.max( product.count - 1, 1 )
						onChange( {product} )
					}} />
				{<input value={product.count-1} tabIndex={99} style={{minWidth: "60px", maxWidth: "70px"}} 
				

				/>}
				<Button style={{backgroundColor:"darkGray"}}
					size="tiny"
					icon="plus"
					onClick={() => {
						if ( shop.config.checkout.limitToStock ) product.count = Math.min( product.count, Math.floor( product.deliveryCount / product.unit_multi ) )
						if(product.count > product.extras.deliveryCount / product.unit_multi){
							/*showWarningToast( "Maximale Abnahmemenge erreicht" )
							return false*/
						}
						if ( product.onChange ) {
							let ok = product.onChange( {count: product.count + 1} )
							/*if ( !ok ) {
								showWarningToast( "Maximale Abnahmemenge erreicht" )
								return false
							}*/
						}
						product.count += 1
						onChange( {product} )
					}} />
				{showVEWarning &&
				<Popup trigger={<Button circular icon="warning" color="yellow" title="Keine weiteren Artikel auf Lager" />}
					   content="Keine weiteren Artikel auf Lager" />}
			</Input>)
	}
}

ProductCount.propTypes = {
	product : PropTypes.any,
	onChange: PropTypes.any
}


export default ProductCount



// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/components/Product/ProductCount.js